import React from 'react';

const JobCard = (props) => {
  var toText = 'To: ';
  var to = props.to;
  if (props.to === '') {
      toText = '-';
      to = 'Currently'
  }
  
  return (
    <div>
      <div className="ui card">
        <div className="image">
          <img src={require('../../../assets/images/jobs/'+props.img)} alt={props.company}></img>
        </div>
        <div className="content">
          <div className="header">{props.rol}</div>
          <div className="meta">
            <span className="date">From: {props.from} {toText} {to}</span>
          </div>
          <div className="description">
            <a href={props.companyUrl} target="_blank">{props.company}</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default JobCard;